import { render, staticRenderFns } from "./AreaPanel.vue?vue&type=template&id=53dabf6e&scoped=true&"
import script from "./AreaPanel.vue?vue&type=script&lang=js&"
export * from "./AreaPanel.vue?vue&type=script&lang=js&"
import style0 from "./AreaPanel.vue?vue&type=style&index=0&id=53dabf6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dabf6e",
  null
  
)

export default component.exports